/**
 * RENDER module — debug surface for QA automation.
 *
 * The frozen DebugRegistry has no render slots and initRender receives no
 * ModuleContext, so the render knobs are exposed as a namespaced object:
 *   - window.__gumshoeRender (always)
 *   - window.__gumshoe.render (attached when core has installed the API)
 *
 * Both point at the same object: { getConfig(), setConfig(partial) }.
 */
import type { NoirPostConfig } from './config'
import type { NoirPipeline } from './pipeline'

export interface RenderDebugApi {
  getConfig(): NoirPostConfig
  setConfig(partial: Partial<NoirPostConfig>): void
}

declare global {
  interface Window {
    __gumshoeRender?: RenderDebugApi
  }
}

export const installRenderDebug = (pipeline: NoirPipeline): void => {
  const api: RenderDebugApi = {
    getConfig: () => pipeline.getConfig(),
    setConfig: (partial) => pipeline.setConfig(partial)
  }

  window.__gumshoeRender = api

  const gumshoe = window.__gumshoe as unknown as Record<string, unknown> | undefined
  if (gumshoe) {
    gumshoe['render'] = api
  }
}
